import { Alert } from "@mui/material";

const InfoTotal = ({ num }) => <Alert severity="success" sx={{ mb: '1em', mt: '1em' }}> Total: <b>{num}</b></Alert>

export default InfoTotal;